
const environment = {
    apiUrl: "https://secretaria.ieadern.org.br/api/"
}

export default environment;
